import { createApp } from "vue";
import App from "./App.vue";
import vuetify from "./plugins/vuetify";
import { loadFonts } from "./plugins/webfontloader";
import router from "./router";
import store from "./store";
import { Amplify } from "aws-amplify";
import VueGoogleMaps from "@fawmi/vue-google-maps";
loadFonts();
async function initApp() {
  Amplify.configure({
    Auth: {
      Cognito: {
        userPoolId: process.env.VUE_APP_AWS_COGNITO_USER_POOL_ID,
        userPoolClientId: process.env.VUE_APP_AWS_USER_POOL_WEB_CLIENT_ID,
        identityPoolId: process.env.VUE_APP_IDENTITY_POOL_ID,
        authMode: "userPool",
        loginWith: {
          email: true,
        },
      },
    },

    API: {
      GraphQL: {
        endpoint: process.env.VUE_APP_AWS_GRAPHQL_ENDPOINT,
        region: process.env.VUE_APP_AWS_PROJECT_REGION,
        defaultAuthMode: "userPool",
      },
      aws_project_region: process.env.VUE_APP_AWS_PROJECT_REGION,
    },

    Storage: {
      S3: {
        bucket: process.env.VUE_APP_AWS_BUCKET_NAME,
        region: process.env.VUE_APP_AWS_PROJECT_REGION,
        logger_level: "DEBUG",
      },
    },
  });

  const app = createApp(App);

  app.use(router);
  app.use(store);
  app.use(vuetify);

  app.use(VueGoogleMaps, {
    load: {
      key: process.env.VUE_APP_GOOGLE_MAPS_API_KEY,
      libraries: "places",
    },
  });
  app.mount("#app");
}

initApp();

// initApp().then(() => {
//   createApp(App).use(router).use(store).use(vuetify).mount("#app");
// });

// createApp(App).use(store).use(router).use(vuetify).mount("#app");
